<ul class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs; let i = index" (click)="onFilterClick(i)">
        <span [class.breadcrumb-text]="i !== breadcrumbs.length - 1" >{{breadcrumb.viewType}}</span>
        <span *ngIf="i!==breadcrumbs.length-1">&nbsp;>&nbsp;</span>
    </li>
</ul>
